// import React, { useEffect, useState } from "react";
// import { getHolidaysData } from "../Services/ApiCalling";
// import Holidays from "./component/holiday";

// function HolidaysView() {
//   const [holidaysData, setHolidaysData] = useState()

//   const token = localStorage.getItem("LogIn_Token")

//   const HolidayData = async (token) => {
//     const res = await getHolidaysData(token)
//     setHolidaysData(res)
//     console.log('resppp', res);
//   }
//   useEffect(() => {
//     HolidayData(token);
//   }, []);
//   return (
//     <>
//       {holidaysData && <Holidays holidaysData={holidaysData} HolidayData={HolidayData}/>}
//     </>
//   );
// }

// export default HolidaysView;

import React, { useState } from "react";
import Holidays from "./component/holiday";

function HolidaysView() {
  // Initialize holidaysData with default value (could be an empty array)
  const [holidaysData, setHolidaysData] = useState([]);

  return (
    <>
      {/* Pass holidaysData and setHolidaysData to the Holidays component */}
      <Holidays holidaysData={holidaysData} setHolidaysData={setHolidaysData} />
    </>
  );
}

export default HolidaysView;
